import api from 'utils/api';

export const loginUser = (data) =>
	api.post('/auth/token?detailsRequired=true', data);

export const forgotPasswordApi = (data) =>
	api.post('/user/reset-password', data);
